export default __webpack_public_path__ + "static/media/IMG_8378.e313aa3e.jpg";